import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-scroll'

const CtaBanner = () => {
    return (
        <section className="cta-banner">
            {/* Decorative floating shapes */}
            <div style={{
                position: 'absolute',
                top: '20%',
                left: '10%',
                width: '80px',
                height: '80px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '20px',
                transform: 'rotate(45deg)',
                animation: 'float 6s ease-in-out infinite'
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '20%',
                right: '10%',
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                animation: 'float 8s ease-in-out infinite reverse'
            }}></div>
            <div style={{
                position: 'absolute',
                top: '50%',
                right: '20%',
                width: '40px',
                height: '40px',
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '12px',
                transform: 'rotate(30deg)',
                animation: 'float 7s ease-in-out infinite'
            }}></div>

            <div className="container">
                <div className="cta-content">
                    <Fade direction="up" triggerOnce={true} duration={1000}>
                        <h2 className="cta-title">Ready to optimize your SaaS spend?</h2>
                    </Fade>
                    <Fade direction="up" triggerOnce={true} duration={1000} delay={100}>
                        <p className="cta-subtitle">
                            Join companies saving up to 30% on their cloud subscriptions. Get started today.
                        </p>
                    </Fade>
                    <Fade direction="up" triggerOnce={true} duration={1000} delay={200}>
                        <Link
                            to="contact"
                            spy={true}
                            smooth={true}
                            duration={500}
                            offset={-100}
                            className="btn-white"
                            style={{ cursor: 'pointer' }}
                        >
                            Get Started
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '10px' }}>
                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </Fade>
                </div>
            </div>
        </section>
    );
};

export default CtaBanner;
